import { UserReview } from 'types';
import {
  ApiUserReview,
  UserReviewsQuery,
  apiCreateReview,
  apiDeleteUserReview,
  apiGetUserReviews,
  apiUpdateUserReview,
} from './client';

export const mapApiUserReview = (apiReview: ApiUserReview): UserReview => ({
  id: apiReview.id,
  bookId: Number(apiReview.book_id),
  book: apiReview.book ?? null,
  authorName: apiReview.author,
  rating: apiReview.rating,
  text: apiReview.text,
  language: apiReview.language ?? 'en',
  status: apiReview.status,
  moderationNote: apiReview.moderation_note,
  date: new Date(apiReview.created_at).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }),
  createdAt: apiReview.created_at,
});

export type UserReviewPage = {
  reviews: UserReview[];
  page: number;
  lastPage: number;
  total: number;
};

export const fetchUserReviewPage = async (
  page = 1,
  query: UserReviewsQuery = {},
): Promise<UserReviewPage> => {
  const res = await apiGetUserReviews(page, query);

  return {
    reviews: res.data.map(mapApiUserReview),
    page: res.current_page,
    lastPage: res.last_page,
    total: res.total,
  };
};

export const approveUserReview = async (review: UserReview) => {
  await apiCreateReview({
    author: review.authorName,
    text: review.text,
    rating: review.rating,
    book_id: review.bookId,
    language: review.language,
  });
  await apiUpdateUserReview(review.id, { status: 'approved' });
};

export const deleteUserReview = (id: number) => apiDeleteUserReview(id);

export type UserReviewChanges = {
  author: string;
  text: string;
  rating: number;
  bookId: number;
  language: string;
  moderationNote: string | null;
};

export const updateUserReview = async (
  id: number,
  changes: UserReviewChanges,
): Promise<UserReview> =>
  mapApiUserReview(
    await apiUpdateUserReview(id, {
      author: changes.author,
      text: changes.text,
      rating: changes.rating,
      book_id: changes.bookId,
      language: changes.language,
      moderation_note: changes.moderationNote,
    }),
  );
